export default __webpack_public_path__ + "static/media/IMG_7421-1poin5-768x507.74572182.jpg";